import React from "react";
import { connect } from "react-redux";
import { Styles } from "../styles";

import { CustomText, InputDate, InputTags } from "../../../components";
import { Colors, Fonts, Spacing, Themes } from "../../../config";
import { Grid } from "@material-ui/core";
import {
  Delete,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Search,
} from "@material-ui/icons";
import { FormHolder } from "../../../FormConfig";

import fonts from "../../../config/fonts";
import { GetRoleByName } from "../../../services";
const now = new Date();
const year = now.getFullYear();
const month = now.getMonth() + 1; // Os meses em JavaScript são indexados de 0 a 11

const begin = new Date(year, month - 1, 1);
const end = now;
function Filters({
  isFetching,
  allUserFullnameList,
  onSubmit,
  onClear,
  userInfos,
}) {
  const [show, setShow] = React.useState(true);
  const [ref, setRef] = React.useState(null);
  const [initDate, setInitDate] = React.useState(begin);

  return (
    <Styles.Content>
      <Styles.HeaderCard>
        <CustomText fontFamily={Fonts.bold} fontSize={1.75}>
          FILTROS DO PAINEL
        </CustomText>
        <Styles.Hide onClick={() => setShow(!show)}>
          {show ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </Styles.Hide>
      </Styles.HeaderCard>
      <Styles.Line></Styles.Line>
      {show && (
        <>
          <FormHolder formRef={setRef} onSubmit={onSubmit}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={5}>
                <InputTags
                  name="companyIds"
                  defaultValue={[]}
                  inputLabel="NOME DO ANALISTA"
                  options={allUserFullnameList ? allUserFullnameList : []}
                  color={GetRoleByName(userInfos?.role?.name)}
                />
              </Grid>
              <Grid
                style={{ display: "flex", alignContent: "flex-start" }}
                container
                item
                spacing={1}
                xs={12}
                sm={12}
                md={7}
              >
                <Grid
                  container
                  item
                  xs={12}
                  style={{ marginBottom: Spacing(-1) }}
                >
                  <CustomText
                    textColor={
                      GetRoleByName(userInfos?.role?.name) === 2
                        ? Themes.Light.palette.text.primary
                        : GetRoleByName(userInfos?.role?.name) === 1
                        ? Colors.orange
                        : Themes.Light.palette.text.primary
                    }
                    fontSize={1.75}
                    fontFamily={fonts.semibold}
                  >
                    PERÍODO
                  </CustomText>
                </Grid>

                <Grid item xs={5}>
                  <InputDate
                    name="begin"
                    nextInput="end"
                    placeholder="dd/mm/yyyy"
                    defaultValue={begin}
                    onChange={(data, value) => {
                      if (
                        ref?.getFieldValue("end") &&
                        ref?.getFieldValue("end") < value
                      ) {
                        setInitDate(value);
                        var novaData = new Date(value);
                        novaData.setDate(value.getDate() + 1);

                        ref?.setValue("end", novaData);
                      } else {
                        setInitDate(value);
                      }
                    }}
                    color={GetRoleByName(userInfos?.role?.name)}
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  style={{ justifyContent: "center", display: "flex" }}
                >
                  <CustomText
                    styles={{ paddingTop: Spacing(1.75) }}
                    fontSize={1.75}
                    fontFamily={fonts.medium}
                  >
                    até
                  </CustomText>
                </Grid>
                <Grid item xs={5}>
                  <InputDate
                    defaultValue={end}
                    minDate={initDate}
                    name="end"
                    placeholder="dd/mm/yyyy"
                    color={GetRoleByName(userInfos?.role?.name)}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Styles.FormButtons>
                  <Styles.FormButtonOutlined
                    startIcon={<Delete />}
                    fullWidth={false}
                    type="clear"
                    loading={isFetching}
                    disabled={isFetching}
                    onClick={() => {
                      ref?.clearAllValues(false);

                      onClear();
                    }}
                    $color={GetRoleByName(userInfos?.role?.name)}
                  >
                    Limpar
                  </Styles.FormButtonOutlined>
                  <Styles.FormButton
                    startIcon={<Search />}
                    fullWidth={false}
                    type="submit"
                    loading={isFetching}
                    disabled={isFetching}
                    $color={GetRoleByName(userInfos?.role?.name)}
                  >
                    Pesquisar
                  </Styles.FormButton>
                </Styles.FormButtons>
              </Grid>
            </Grid>
          </FormHolder>
        </>
      )}
    </Styles.Content>
  );
}

function mapStateToProps(redux) {
  const { isFetching: isFetchingPage } = redux.dashboardAmcred;
  const { isFetching: isFetchingGlobal } = redux.global;
  return { isFetching: isFetchingGlobal || isFetchingPage };
}
function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(Filters));
